import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EMPTY, Observable, of, pipe } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { InsurerDto, RefLanguageDto } from 'src/app/api/models';
import { InsurerService, ReferentialService } from 'src/app/api/services';
import { TranslationService } from 'src/app/core/services/translation.service';
import { eKioskError } from 'src/app/shared/models/api/constants';
import { AppState } from 'src/app/state/app.state';
import { setErrorMsg } from '../../error/state/error.actions';
import { setSelectedInsurer, setSelectedInsurerFailure, setSelectedInsurerSuccess, setSelectedLanguage, setSelectedLanguageFailure, setSelectedLanguageSuccess } from './transaction-info.actions';



@Injectable()
export class TransactionInfoEffects {

	constructor(private actions$: Actions, private insurerService: InsurerService, private store: Store<AppState>,
		private referentialService: ReferentialService, private translationService: TranslationService) { }

	public setSelectedInsurer$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(setSelectedInsurer),
			switchMap(({ data, insurerId }) => {
				var resInsurer: Observable<InsurerDto> = null;
				if (data) {
					resInsurer = of(data);
				}
				else if (insurerId) {
					resInsurer = this.insurerService.insurerGet({ InsurerId: insurerId }).pipe(
						map((insurer) => {
							if (insurer == null || insurer.length == 0)
								throw new Error(eKioskError[eKioskError.CONTRACT_NOT_KNOWN])

							return insurer[0];
						}))
				}
				else
					resInsurer = of(null);

				return resInsurer;
			}),
			switchMap((data) => of(setSelectedInsurerSuccess({ data: data }))),
			catchError((err) => {
				this.store.dispatch(setErrorMsg({ data: null, KioskError: eKioskError.CONTRACT_NOT_KNOWN }));
				return of(setSelectedInsurerFailure({ error: err }));
			})
		);
	});

	public setSelectedLanguage$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(setSelectedLanguage),
			switchMap(({ data, languageCode }) => {

				var resLanguage: RefLanguageDto = null;
				if (data) {
					return of(data);
				}
				else if (languageCode) {
					return this.referentialService.referentialGetLanguages$Json({languageCode: languageCode}).pipe(
						map((language) => {
							return language.find(x => x.languageCode == languageCode);
						})
					)
				}
				else
					resLanguage = null;


				return of(resLanguage);
			}),
			switchMap((language) => {
				if (language) {
					return this.translationService.changeAppLanguage(language?.languageCode ?? "fr").pipe(map(() => language));
				}
				else
					return of(null);
			}),
			switchMap((language) => of(setSelectedLanguageSuccess({ data: language }))),
			catchError((err) => of(setSelectedLanguageFailure({ error: err })))
		)
	});
}